const state = {
  source: null,
  countrys: null
}

const getters = {
  source: state => state.source,
  countrys: state => state.countrys || []
}

const types = {
  setSource: 'global/setSource',
  setCountrys: 'global/setCountrys'
}

const mutations = {
  [types.setSource] (state, object) {
    state.source = object
  },
  [types.setCountrys] (state, object) {
    state.countrys = object
  }
}

const actions = {
  setSourceAction ({commit}, object) {
    commit(types.setSource, object)
  },
  setCountrysAction ({commit}, object) {
    commit(types.setCountrys, object)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js